import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { DataProvider } from "./data/DataContext";
import { UIProvider } from "./data/UIContext";
import { LoginPage } from "./pages/LoginPage";
import { CallbackPage } from "./auth/CallbackPage";
import { Layout } from "./components/Layout";
import { BackendTab } from "./pages/BackendTab";
import { SurfacesTab } from "./pages/SurfacesTab";
import { IntegrationsTab } from "./pages/IntegrationsTab";
import { ClientsTab } from "./pages/ClientsTab";
import { ScorecardTab } from "./pages/ScorecardTab";
import { SloTab } from "./pages/SloTab";
import { InfraTab } from "./pages/InfraTab";
import { LogsTab } from "./pages/LogsTab";
import { AlertHealthTab } from "./pages/AlertHealthTab";
import { CoverageTab } from "./pages/CoverageTab";
import { IncidentsTab } from "./pages/IncidentsTab";
import { CicdTab } from "./pages/CicdTab";
import { DashboardsTab } from "./pages/DashboardsTab";
import { DoraTab } from "./pages/DoraTab";
import { GraphTab } from "./pages/GraphTab";
import { ToolsTab } from "./pages/ToolsTab";
import { RuntimeTab } from "./pages/RuntimeTab";
import { ExperienceTab } from "./pages/ExperienceTab";
import { RenewalsTab } from "./pages/RenewalsTab";
import { DataPipelinesTab } from "./pages/DataPipelinesTab";
import { ScaffoldTab } from "./pages/ScaffoldTab";
import { SearchResults } from "./pages/SearchResults";

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <UIProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<CallbackPage />} />
            <Route
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route index element={<Navigate to="/backend" replace />} />
              <Route path="/backend"      element={<BackendTab />} />
              <Route path="/surfaces"     element={<SurfacesTab />} />
              <Route path="/integrations" element={<IntegrationsTab />} />
              <Route path="/clients"      element={<ClientsTab />} />
              <Route path="/scorecard"    element={<ScorecardTab />} />
              <Route path="/slo"          element={<SloTab />} />
              <Route path="/infra"        element={<InfraTab />} />
              <Route path="/logs"         element={<LogsTab />} />
              <Route path="/alert-health" element={<AlertHealthTab />} />
              <Route path="/coverage"     element={<CoverageTab />} />
              <Route path="/incidents"    element={<IncidentsTab />} />
              <Route path="/cicd"         element={<CicdTab />} />
              <Route path="/dashboards"   element={<DashboardsTab />} />
              <Route path="/dora"         element={<DoraTab />} />
              <Route path="/graph"        element={<GraphTab />} />
              <Route path="/tools"        element={<ToolsTab />} />
              {/* Wave-2 planned domains — graceful "planned" tabs until their data source lands */}
              <Route path="/platform-kpis"  element={<ScaffoldTab slug="platform-kpis" />} />
              <Route path="/traces"         element={<ScaffoldTab slug="traces" />} />
              <Route path="/data-stores"    element={<ScaffoldTab slug="data-stores" />} />
              <Route path="/runtime"        element={<RuntimeTab />} />
              <Route path="/experience"     element={<ExperienceTab />} />
              <Route path="/renewals"       element={<RenewalsTab />} />
              <Route path="/security"       element={<ScaffoldTab slug="security" />} />
              <Route path="/cost"           element={<ScaffoldTab slug="cost" />} />
              <Route path="/ai-agents"      element={<ScaffoldTab slug="ai-agents" />} />
              <Route path="/data-pipelines" element={<DataPipelinesTab />} />
              <Route path="/search"       element={<SearchResults />} />
              <Route path="*" element={<Navigate to="/backend" replace />} />
            </Route>
          </Routes>
        </UIProvider>
      </DataProvider>
    </AuthProvider>
  );
}
